import React, { useState, useCallback } from 'react';
import { FieldError } from 'react-hook-form';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { formatId } from '@@/utils/string';
import TextareaAutosize from 'react-textarea-autosize';

const StandardInput: React.FC<{
  register: any;
  id: string;
  label: string | JSX.Element;
  type: string;
  cb?: Function;
  rows?: number;
  placeholder?: string;
  error?: FieldError;
  disabled?: boolean;
  inputClassName?: string;
  labelClassName?: string;
  errorClassName?: string;
}> = ({
  register,
  id,
  label,
  type,
  cb,
  rows,
  placeholder,
  error,
  disabled,
  inputClassName = 'peer block w-full ring-1 ring-gray-200 shadow-sm py-3 px-4 border-main rounded-md placeholder-transparent font-main text-main text-sm',
  labelClassName = 'absolute pointer-events-none font-main text-main text-sm -top-7 left-0 transition-all peer-focus:-top-6 peer-focus:left-0 peer-focus:text-sm peer-placeholder-shown:top-3 peer-placeholder-shown:left-3.5 peer-placeholder-shown:text-base peer-placeholder-shown:italic',
  errorClassName = 'italic font-main text-sm text-red-500 m-1',
}) => {
  const errorComponent = error?.message && (
    <p className={errorClassName}>{error.message}</p>
  );

  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = useCallback(() => {
    setShowPassword((prevState) => !prevState);
  }, [setShowPassword]);

  if (type === 'textarea') {
    return (
      <div className="relative w-full">
        <TextareaAutosize
          {...register(id)}
          onChange={(e) => {
            register(id).onChange(e);
            if (typeof cb === 'function') {
              cb(e.target.value);
            }
          }}
          id={id}
          minRows={rows || 1}
          placeholder={placeholder}
          className={inputClassName}
          aria-invalid={error ? 'true' : 'false'}
          disabled={!!disabled}
        />
        <label
          id={formatId(typeof label === 'string' ? label : id)}
          htmlFor={id}
          className={labelClassName}
        >
          {label}
        </label>
        {errorComponent}
      </div>
    );
  }

  return (
    <div className="relative w-full">
      <input
        {...register(id)}
        onChange={(e) => {
          register(id).onChange(e);
          if (typeof cb === 'function') {
            cb(e.target.value);
          }
        }}
        id={id}
        type={showPassword ? 'text' : type}
        placeholder={placeholder}
        className={inputClassName}
        aria-invalid={error ? 'true' : 'false'}
        disabled={!!disabled}
      />

      {type === 'password' && (
        <button
          type="button"
          className="absolute right-3 top-3"
          onClick={togglePasswordVisibility}
        >
          {showPassword ? <FaEyeSlash /> : <FaEye />}
        </button>
      )}

      <label
        id={formatId(typeof label === 'string' ? label : id)}
        htmlFor={id}
        className={labelClassName}
      >
        {label}
      </label>
      {errorComponent}
    </div>
  );
};

export default StandardInput;
